import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * PDP low-stock indicator (blocks/low-stock.liquid).
 * Fabric doesn't re-render the section on variant change, so this element listens for the
 * product select event on its section (or Quick Add dialog) and morphs its children from
 * the fetched page HTML, the same way assets/product-inventory.js does.
 */
class SscLowStock extends Component {
  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    super.connectedCallback();

    this.#abortController?.abort();
    this.#abortController = new AbortController();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.handleProductSelect, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
    this.#abortController = undefined;
  }

  /**
   * Swaps in the low-stock markup rendered for the newly selected variant.
   * @param {ProductSelectEvent} event - The product select event.
   */
  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html || !this.isConnected) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = String(newProduct.id);
        } else if (detail.productId && String(detail.productId) !== this.dataset.productId) {
          return;
        }

        const next = this.id ? html.querySelector(`#${CSS.escape(this.id)}`) : null;
        if (!next) return;

        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[ssc-low-stock] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('ssc-low-stock')) {
  customElements.define('ssc-low-stock', SscLowStock);
}
